// NOTE: This is a draft legal text. Review by a legal professional is recommended.
import LegalPage from "@/components/LegalPage";
import { LEGAL_VERSIONS } from "@/lib/legalVersions";

export default function CookiePolicyEn() {
  return (
    <LegalPage
      lang="en"
      title="Cookie Policy"
      subtitle="How and why uSeen uses cookies and similar technologies."
      lastUpdated="May 2026"
      version={LEGAL_VERSIONS.cookies}
      testid="cookie-policy-page-en"
    >
      <h2>1. What Are Cookies?</h2>
      <p>
        Cookies are small text files that websites place on your device to
        remember information such as your preferences and session state.
        Similar technologies include localStorage and pixels.
      </p>

      <h2>2. Categories We Use</h2>
      <ul>
        <li>
          <strong>Necessary cookies</strong> keep the platform secure and
          functional (e.g. authentication session). These cannot be disabled.
        </li>
        <li>
          <strong>Analytics cookies</strong> measure how the product is used,
          anonymously, so we can improve it. These run only with your consent.
        </li>
        <li>
          <strong>Marketing cookies</strong> support relevant product
          communication. Off by default; only on with your explicit consent.
        </li>
      </ul>

      <h2>3. Managing Your Choices</h2>
      <p>
        {"You can change your cookie preferences any time using the \"Cookie preferences\" link in the footer. Existing consent can be revoked at any time and we will apply the change immediately."}
      </p>

      <h2>4. Third-Party Cookies</h2>
      <p>
        Analytics is currently powered by PostHog, gated behind your consent
        choice. We do not load it for users who have opted out.
      </p>

      <h2>5. Retention</h2>
      <p>
        Necessary cookies expire when your session ends or shortly after.
        Analytics consent records are kept for a reasonable period to remember
        your preference.
      </p>

      <h2>6. Contact</h2>
      <p>
        For questions about this cookie policy, use the contact page.
      </p>
    </LegalPage>
  );
}
